<template>
    <div class="charts-container">
        <!--                <iframe src="" id="frame" scrolling="no" frameborder="0" style="position:absolute;"></iframe>-->
        <el-card id="id_253piedata" class="data-charts"/>
        <el-card id="id_253bardata" class="data-charts"/>
<!--        <el-card id="id_opendata" class="data-charts"/>-->
<!--        <el-card id="id_outsidedata" class="data-charts"/>-->
<!--        <el-card id="id_motiondata" class="data-charts"/>-->
        <el-card id="id_activedata" class="data-charts"/>
        <div id="id_heatmap" class="map-charts"/>
    </div>
</template>

<script>
    import echarts from "echarts"
    import 'echarts/extension/bmap/bmap.js'

    export default {
        data() {
            return {}
        },
        mounted() {
            var pie253Chart = document.getElementById('id_253piedata');
            var bar253Chart = document.getElementById('id_253bardata');
            // var opendataChart = document.getElementById('id_opendata');
            // var outsidedataChart = document.getElementById('id_outsidedata');
            // var motiondataChart = document.getElementById('id_motiondata');
            var activedataChart = document.getElementById('id_activedata');
            var heatmapChart = document.getElementById('id_heatmap');

            function initMap(chart, data) {
                var mchart = echarts.init(chart);
                mchart.setOption({
                    animation: false,
                    bmap: {
                        center: [94.16181, 37.417],//[120.13066322374, 30.240018034923],
                        zoom: 5,
                        roam: true
                    },
                    visualMap: {
                        show: false,
                        top: 'top',
                        min: 0,
                        max: 5,
                        seriesIndex: 0,
                        calculable: true,
                        inRange: {
                            color: ['blue', 'blue', 'green', 'yellow', 'red']
                        }
                    },
                    series: [{
                        type: 'heatmap',//scatter
                        coordinateSystem: 'bmap',
                        data: data,
                        pointSize: 5,
                        blurSize: 6
                    }]
                });
                var bmap = mchart.getModel().getComponent('bmap').getBMap();
                var navigationCtrl = new BMap.NavigationControl({
                    anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                    type: BMAP_NAVIGATION_CONTROL_LARGE
                });
                bmap.addControl(navigationCtrl);
                // bmap.addControl(new BMap.MapTypeControl());
                /*缩放控件type有四种类型:
                BMAP_NAVIGATION_CONTROL_LARGE：标准
                BMAP_NAVIGATION_CONTROL_SMALL：仅包含平移和缩放按钮；
                BMAP_NAVIGATION_CONTROL_PAN:仅包含平移按钮；
                BMAP_NAVIGATION_CONTROL_ZOOM：仅包含缩放按钮
                */
                bmap.setMapStyle({style: 'grayscale'});
            }

            function initPieChart(title) {
                var option;
                echarts.init(pie253Chart).setOption({
                    backgroundColor: '#2c343c',

                    title: {
                        text: title,
                        left: 'center',
                        top: 10,
                        textStyle: {
                            color: '#8492A6',
                            fontSize: 10
                        }
                    },

                    // grid: {
                    //     top: '20%',
                    //     left: '5%',
                    //     right: '6%',
                    //     bottom: '5%',
                    //     containLabel: true
                    // },

                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}%"
                    },
                    textStyle: {
                        fontSize: 8
                    },
                    visualMap: {
                        show: false,
                        min: 0,
                        max: 100,
                        inRange: {
                            colorLightness: [0, 1]
                        }
                    },
                    series: [
                        {
                            name: '日均时长',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '50%'],
                            data: [
                                {value: 31.0, name: '超过4h'},
                                {value: 50.7, name: '约2h'},
                                {value: 18.3, name: '小于1h'}
                            ].sort(function (a, b) {
                                return a.value - b.value;
                            }),
                            roseType: 'radius',
                            label: {
                                normal: {
                                    textStyle: {
                                        color: '#8492A6',
                                        fontSize: 11
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    lineStyle: {
                                        color: '#8492A6',
                                        opacity: 0.3
                                    },
                                    smooth: 0.2,
                                    length: 10,
                                    length2: 20
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#c23531',
                                    shadowBlur: 400,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },

                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: function (idx) {
                                return Math.random() * 200;
                            }
                        }
                    ]
                });
            }

            function initChart(chart, xdata, ydata, title, seriestype, seriesshowlabel) {
                echarts.init(chart).setOption({
                    title: {
                        text: title,
                        left: 'center',
                        textStyle: {
                            color: '#8492A6',
                            fontSize: 10
                        }
                    },
                    color: ['#8492A6', 'rgb(33, 193, 220)', '#3398DB'],
                    grid: {
                        top: '20%',
                        left: '5%',
                        right: '6%',
                        bottom: '5%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: xdata,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#d2e2e2'
                            }
                        },
                        axisLabel: {
                            color: '#8492A6',
                            fontWeight: 'bold',
                            fontSize: 8
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['#e2e2e2'],
                                type: 'dotted'
                            }
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: '#8492A6',
                            fontWeight: 'bold',
                            fontSize: 10
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: seriestype,
                            barWidth: '55%',
                            data: ydata,
                            label: {
                                normal: {
                                    show: seriesshowlabel,
                                    position: 'top',
                                    fontSize: 8,
                                    formatter: '{c}%',
                                    fontWeight: 'bold'
                                }
                            }
                        }
                    ]
                });
            }

            function setChartSize() {
                var w, h, marginVertical, marginHorizontol;
                marginVertical = 15;
                marginHorizontol = marginVertical;
                w = heatmapChart.offsetWidth / 4;
                h = (heatmapChart.offsetHeight - 4 * marginVertical) / 3;


                activedataChart.style.width = w + 'px';
                activedataChart.style.height = h + 'px';
                activedataChart.style.marginTop = marginVertical + 'px';
                activedataChart.style.marginLeft = marginHorizontol + 'px';
                activedataChart.style.backgroundColor = '#fff';

                pie253Chart.style.width = w + 'px';
                pie253Chart.style.height = h + 'px';
                pie253Chart.style.marginTop = (marginVertical * 2 + h * 1) + 'px';
                pie253Chart.style.marginLeft = marginHorizontol + 'px';
                pie253Chart.style.backgroundColor = '#fff';

                bar253Chart.style.width = w + 'px';
                bar253Chart.style.height = h + 'px';
                bar253Chart.style.marginTop = (marginVertical * 3 + h * 2) + 'px';
                bar253Chart.style.marginLeft = marginHorizontol + 'px';
                bar253Chart.style.backgroundColor = '#fff';

                // opendataChart.style.width = w + 'px';
                // opendataChart.style.height = h + 'px';
                // opendataChart.style.marginTop = marginVertical + 'px';
                // opendataChart.style.marginLeft = marginHorizontol + 'px';
                // opendataChart.style.backgroundColor = '#fff';

                // outsidedataChart.style.width = w + 'px';
                // outsidedataChart.style.height = h + 'px';
                // outsidedataChart.style.marginTop = (marginVertical * 2 + h * 1) + 'px';
                // outsidedataChart.style.marginLeft = marginHorizontol + 'px';
                // outsidedataChart.style.backgroundColor = '#fff';

                // motiondataChart.style.width = w + 'px';
                // motiondataChart.style.height = h + 'px';
                // motiondataChart.style.marginTop = (marginVertical * 3 + h * 2) + 'px';
                // motiondataChart.style.marginLeft = marginHorizontol + 'px';
                // motiondataChart.style.backgroundColor = '#fff';

                // activedataChart.style.width = w + 'px';
                // activedataChart.style.height = h + 'px';
                // activedataChart.style.right = 0;
                // activedataChart.style.marginTop = (marginVertical * 3 + h * 2) + 'px';
                // activedataChart.style.marginRight = marginHorizontol + 10 + 'px';// 父布局padding为10px
                // activedataChart.style.backgroundColor = '#fff';
            }

            setChartSize();
            var heatmapdata = require('../assets/heatmapdata');
            initMap(heatmapChart, heatmapdata);
            initPieChart('日均使用时长设备数量分布');
            initChart(bar253Chart,['超过4h','约2h','小于1h'],['87.07','73.83','45.42'],'设备使用频率分布','bar',true);
            // initChart(opendataChart, ['0~1h', '1~2h', '2~3h', '3~4h', '>4h'], ['19.0', '20.0', '23.0', '7.0', '31.0'], '日均使用时长设备数量分布', 'bar', true);
            // initChart(outsidedataChart, ['0~0.5h', '0.5~1h', '1~1.5h', '1.5~2h', '>2h'], ['39.9', '36.9', '11.8', '7.9', '3.5'], '日均室外时长设备数量分布', 'bar', true);
            // initChart(motiondataChart, ['0~45min', '45~90min', '90~135min', '135~180min', '>180min'], ['20.0', '36.0', '27.8', '5.8', '10.4'], '日均协助转移时长设备数量分布', 'bar', true);
            var x = [], y = [];
            var i;
            var activedata = require('../assets/activedata1.json');
            for (i = 0; i < activedata.length; i++) {
                x[i] = activedata[i][0];
                y[i] = activedata[i][1];
            }
            initChart(activedataChart, x, y, '日活跃设备百分比趋势', 'line', false);
            setChartSize();// 重新设置背景颜色


            window.onresize = function () {
                // setChartSize();
            }

            /*
            function changeMobsfIframe() {
                const mobsf = document.getElementById('frame');
                const deviceWidth = document.documentElement.clientWidth;
                const deviceHeight = document.documentElement.clientHeight;
                mobsf.style.width = (Number(deviceWidth) - 250) + 'px'; //数字是页面布局宽度差值
                mobsf.style.height = (Number(deviceHeight) - 100) + 'px'; //数字是页面布局高度差
            }

            function generateUrl() {
                const crypto = require('crypto');
                var token = "3bcf6d0727f8fa88ee5dff28e9a555c4";
                var time = Date.now();
                var stringToSign = time.toString();
                var signature = crypto.createHmac('sha256', token).update(stringToSign).digest().toString('base64');
                var url = "http://bi.bangbangrobotics.com" + "?time=" + time + "&signature=" + encodeURIComponent(signature);
                console.log('lbfurl', url);
                const mobsf = document.getElementById('frame');
                mobsf.src = url;
            }

            changeMobsfIframe();
            generateUrl();

            window.onresize = function () {
                changeMobsfIframe();
            }
             */
        }
    }
</script>

<style scoped>
    .box-card {
        /*height: 500px;*/
        /*width: 300px;*/
    }

    .charts-container {
        width: 100%;
        height: 100%;
    }

    .map-charts {
        width: 100%;
        height: 100%;
    }

    .data-charts {
        width: 10px;
        height: 10px;
        position: absolute;
        z-index: 2;
    }

    .title-text {
        font-weight: bold;
        font-size: 15px;
        display: inline-block;
        color: #5F6E82;
        margin-left: 6%;
        margin-top: 2%;
    }

    .range-text {

        font-size: 12px;
        margin-top: 3px;
        margin-left: 6%;
    }
</style>


// WEBPACK FOOTER //
// OverviewManagement.vue?e7bfa42e